var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[(_vm.app)?_c('div',{staticClass:"navbar"},[_c('img',{staticClass:"logo",attrs:{"src":_vm.app.image,"alt":""}})]):_vm._e(),_vm._v(" "),(_vm.loaded)?_c('router-view',{attrs:{"app":_vm.app}}):_c('div',{staticClass:"loader"},[_c('b-spinner',{attrs:{"type":"grow"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2582c24d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = null
// module chunks = 